import {ISettings, ISSUES_INDEX} from "./models";
import {IConfiguration} from "./models";
import Immutable = require('immutable');
import {filterConfigurations} from "./utils";

export function calculateQuoteAmount(userChoices: string[], settings: ISettings, configurations: IConfiguration[]) : number {
    var expandedUserChoices = expandUserChoices(userChoices);

    var fixingCost = Immutable.List(expandedUserChoices)
        .map(userChoice => filterConfigurations(configurations, userChoice, ISSUES_INDEX + 1)[0])
        .reduceRight((fixingCost, config) => {
            return fixingCost + calculateFixingCost(config, settings)
        }, 0);

    return fixingCost + settings.courier;
}

function expandUserChoices(userChoices: string[]) : string[][] {

    var issues = userChoices[ISSUES_INDEX];

    return Immutable.List(issues.split(",")).map( issue =>
        Immutable.List(userChoices)
            .take(ISSUES_INDEX + 1)
            .toList()
            .set(ISSUES_INDEX, issue)
            .toArray()
    ).toArray();
}

function calculateFixingCost(config: IConfiguration, settings: ISettings) : number {

    var markup = config.price * (config.markup / 100);
    var withMarkup = config.price + markup;
    var withLabour = withMarkup + settings.labour;
    var vat = withLabour * (settings.vat / 100);

    return withLabour + vat;

}
